import {Component, Output, EventEmitter} from '@angular/core';
import {Observable} from "rxjs";
import {Wod} from "../../../model/wod";
import {Store} from "@ngxs/store";
import {AppointmentState} from "../../../state/appointment.state";
import {Participant} from "../../../model/participant";

@Component({
  selector: 'app-data-v1',
  templateUrl: './data-v1.component.html',
  styleUrls: ['./data-v1.component.scss']
})
export class DataV1Component {
  public timeslot$: Observable<Wod>;
  @Output() participantSelected = new EventEmitter<Participant>();

  constructor(private store: Store) {
    this.timeslot$ = this.store.select(AppointmentState.currentAppointment);
  }
}
